module.exports = __webpack_public_path__ + "static/media/all.b569fb3f.pred";